import { DataGridNoRecords } from 'src/asio-neon-components/DataGridNoRecords/DataGridNoRecords';
import Locale from 'src/i18n';
import { formatMessage } from 'src/i18n/intl';

export const NoRowsOverlay = ({ hasActiveFilters, downloadSampleFile }) => {
    // If there are active filters/search but no results, show "no results" message
    if (hasActiveFilters) {
        return (
            <DataGridNoRecords
                messageLine1={formatMessage(Locale.gridNoRecordsFoundMsgLine1)}
                messageLine2={formatMessage(Locale.gridNoRecordsFoundMsgLine2)}
            />
        );
    }
    // Otherwise show the default "no records" message
    return (
        <DataGridNoRecords
            messageLine1={formatMessage(Locale.noImportRecordsLine1)}
            messageLine2={formatMessage(Locale.noImportRecordsLine2)}
            actionHandler={downloadSampleFile}
            actionText={formatMessage(Locale.downloadTemplate)}
            imgSrc="/images/No_Bulk_imports.svg"
        />
    );
};

export default NoRowsOverlay;
